import {OrderItem} from './OrderItem';
import {ReviewItem} from './ReviewItem';
import {MenuListItem} from './MenuListItem';
import {FavoriteItem} from './FavoriteItem';
import {PromocodeItem} from './PromocodeItem';
import {RecomendedItem} from './RecomendedItem';
import {HomeReviewItem} from './HomeReviewItem';

export const items = {
  OrderItem,
  ReviewItem,
  FavoriteItem,
  MenuListItem,
  PromocodeItem,
  RecomendedItem,
  HomeReviewItem,
};
